import { render, staticRenderFns } from "./PlatformAvatar.vue?vue&type=template&id=dfb25e34&scoped=true"
import script from "./PlatformAvatar.vue?vue&type=script&lang=ts"
export * from "./PlatformAvatar.vue?vue&type=script&lang=ts"
import style0 from "./PlatformAvatar.vue?vue&type=style&index=0&id=dfb25e34&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb25e34",
  null
  
)

export default component.exports